import Card from '@mui/material/Card';
import {Box, CardContent, CardHeader, Typography} from '@mui/material';

const Component = (props: any) => {
  return (
    <Card variant="outlined" sx={{borderRadius: 0, p: '45px 40px'}}>
      {props.icon && (
        <Box sx={{fontSize: '32px', color: 'primary.main', pb: 2}}>
          {props.icon}
        </Box>
      )}
      <Typography component={'p'} variant="body1" sx={{fontWeight: 'bold'}}>
        {props.heading}
      </Typography>
      {/* <CardContent></CardContent>
       */}
      <Box>{props.children || props.body}</Box>
    </Card>
  );
};
export default Component;
